import React, { useState, useEffect } from 'react';
import Header from '../../components/ui/Header';
import ServicesHeroSection from './components/ServicesHeroSection';
import ServiceCategoriesSection from './components/ServiceCategoriesSection';
import ServiceConfiguratorSection from './components/ServiceConfiguratorSection';

const ServicesPage = () => {
  const [currentLanguage, setCurrentLanguage] = useState('en');

  useEffect(() => {
    const savedLanguage = localStorage.getItem('language');
    if (savedLanguage) {
      setCurrentLanguage(savedLanguage);
    }
  }, []);

  const handleConsultationRequest = () => {
    const configuratorSection = document.getElementById('service-configurator');
    if (configuratorSection) {
      const headerHeight = 80;
      const targetPosition = configuratorSection.offsetTop - headerHeight;
      
      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <div className="min-h-screen bg-background">
      <Header />
      
      <main>
        <ServicesHeroSection onConsultationRequest={handleConsultationRequest} />
        <ServiceCategoriesSection />
        <ServiceConfiguratorSection />
      </main>

      {/* Footer */}
      <footer className="bg-primary text-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-4 gap-8">
            {/* Company Info */}
            <div className="md:col-span-2">
              <div className="flex items-center space-x-3 mb-6">
                <div className="flex items-center justify-center w-10 h-10 bg-white rounded-lg">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3 21L12 2L21 21H3Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="var(--color-primary)"/>
                  </svg>
                </div>
                <div>
                  <h3 className="text-xl font-bold">AlumERP</h3>
                  <p className="text-sm opacity-80">
                    {currentLanguage === 'en' ? 'Aluminum Extrusion ERP' : 'एल्यूमीनियम एक्सट्रूज़न ERP'}
                  </p>
                </div>
              </div>
              <p className="text-sm opacity-80 leading-relaxed mb-6">
                {currentLanguage === 'en' ?'Comprehensive ERP services designed specifically for aluminum extrusion manufacturers. From implementation to ongoing support, we ensure your success.' :'एल्यूमीनियम एक्सट्रूज़न निर्माताओं के लिए विशेष रूप से डिज़ाइन की गई व्यापक ERP सेवाएं। कार्यान्वयन से लेकर निरंतर सहायता तक, हम आपकी सफलता सुनिश्चित करते हैं।'}
              </p>
              <div className="flex space-x-4">
                <div className="text-center">
                  <div className="text-2xl font-bold">500+</div>
                  <div className="text-xs opacity-80">
                    {currentLanguage === 'en' ? 'Implementations' : 'कार्यान्वयन'}
                  </div>
                </div>
                <div className="text-center">
                  <div className="text-2xl font-bold">99.2%</div>
                  <div className="text-xs opacity-80">
                    {currentLanguage === 'en' ? 'Success Rate' : 'सफलता दर'}
                  </div>
                </div>
                <div className="text-center">
                  <div className="text-2xl font-bold">24/7</div>
                  <div className="text-xs opacity-80">
                    {currentLanguage === 'en' ? 'Support' : 'सहायता'}
                  </div>
                </div>
              </div>
            </div>

            {/* Services */}
            <div>
              <h4 className="font-semibold mb-4">
                {currentLanguage === 'en' ? 'Our Services' : 'हमारी सेवाएं'}
              </h4>
              <ul className="space-y-2 text-sm opacity-80">
                <li><a href="#service-categories" className="hover:opacity-100 transition-opacity">
                  {currentLanguage === 'en' ? 'Implementation' : 'कार्यान्वयन'}
                </a></li>
                <li><a href="#service-categories" className="hover:opacity-100 transition-opacity">
                  {currentLanguage === 'en' ? 'Training' : 'प्रशिक्षण'}
                </a></li>
                <li><a href="#service-categories" className="hover:opacity-100 transition-opacity">
                  {currentLanguage === 'en' ? 'Support' : 'सहायता'}
                </a></li>
                <li><a href="#service-categories" className="hover:opacity-100 transition-opacity">
                  {currentLanguage === 'en' ? 'Consulting' : 'परामर्श'}
                </a></li>
              </ul>
            </div>

            {/* Contact Info */}
            <div>
              <h4 className="font-semibold mb-4">
                {currentLanguage === 'en' ? 'Contact Us' : 'हमसे संपर्क करें'}
              </h4>
              <div className="space-y-2 text-sm opacity-80">
                <p>+91 98765 43210</p>
                <p>services@alumerp.com</p>
                <p>
                  {currentLanguage === 'en' ?'Mumbai, Delhi, Bangalore, Chennai' :'मुंबई, दिल्ली, बैंगलोर, चेन्नई'}
                </p>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default ServicesPage;